export const resetStateNullAction = ()=>{
    return{
        type:"RETURN_TO_NULL",
        payload:null,
    };
};

